//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'FibFooter',
  components: {
    FibPrivacyPolicy: require("../pages/modals/PrivacyPolicy").default
  },
  props: {
    inverse: {
      type: Boolean,
      default: false
    },
    logo: {
      type: Boolean,
      default: false
    },
    showLogoutButton: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      privacy: false
    };
  },
  computed: {
    color: function color() {
      if (this.inverse) {
        return 'white';
      }

      return '#B3B0BE';
    }
  }
};